import React from 'react';

export const GiphyIcon = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <path
        id="prefix__a"
        d="M16.8 0c.11 0 .2.09.2.2v12.6a.2.2 0 01-.2.2H.2a.2.2 0 01-.2-.2V.2C0 .09.09 0 .2 0h16.6zM16 1H1v11h15V1zM9 3v7H8V3h1zm5 0v1h-3v2h2v1h-2v3h-1V3h4zM7 3v2H6V4H4.71c-.187 0-.348.078-.485.195S4 4.493 4 4.74V9h2V7H5V6h2v4H3V4.74c0-.287.05-.54.15-.76a1.605 1.605 0 01.945-.87c.203-.073.408-.11.615-.11H7z"
      />
    </defs>
    <g fillRule="evenodd" transform="translate(4 5)">
      <mask id="prefix__b">
        <use xlinkHref="#prefix__a"></use>
      </mask>
      <use fillRule="nonzero" xlinkHref="#prefix__a"></use>
      <g mask="url(#prefix__b)">
        <path d="M-1-3h19v19H-1z" />
      </g>
    </g>
  </svg>
);
